// 角色职能 store
import * as roleFunc from '@/api/manage/roleFunc'
import { getLanguageStr } from '@/util/language'

const state = {
  roleList: [],
  functionalList: [],
  structList: [],
  originRolesMap: {
    // 默认普通用户权限
    allRole: {
      text: getLanguageStr('role1', '全局'),
      isOn: 2, // 1:半选状态  0:未选状态 2：单个选中状态
      parent: 'allRole',
      selected: true,
      disabled: false,
      code: 'Z',
      allModulesStatus: 0, // 所有的模块选择状态
      modules: {
        homes: {
          text: getLanguageStr('word204', '电站'),
          parent: 'homes',
          isOn: 0,
          selected: true,
          disabled: false,
          code: 'Z/A',
          funAuth: [
            {
              text: getLanguageStr('cmd183', '编辑电站'),
              code: 'A/B/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd184', '设置电站'),
              code: 'A/B/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd185', '删除电站'),
              code: 'A/B/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd187', '查看电站详情'),
              code: 'A/B/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd188', '查看子系统/设备'),
              code: 'A/B/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd189', '添加新子系统/设备'),
              code: 'A/B/A8',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd190', '编辑子系统/设备'),
              code: 'A/B/A9',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd191', '删除子系统/设备'),
              code: 'A/B/A10',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd193', '查看关于电站'),
              code: 'A/B/A12',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd194', '查看授权信息'),
              code: 'A/B/A13',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('word1771', '查看所属标签'),
              code: 'A/B/A16',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('manage324', '查看系统布局'),
              code: 'A/B/A21',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('manage24', '授权成员'),
              code: 'A/B/A14',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd196', '移除成员'),
              code: 'A/B/A15',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('word1716', '授权用户'),
              code: 'A/B/A17',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd238', '移除用户'),
              code: 'A/B/A18',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('word297', '授权商家'),
              code: 'A/B/A19',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            },
            {
              text: getLanguageStr('cmd240', '移除商家'),
              code: 'A/B/A20',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'homes'
            }
            
          ],
          dataAuth: {
            resourceType: 1,
            value: 1,
            data: [
              {
                text: getLanguageStr('word1567', '本人的电站'),
                value: 1,
                disabled: false
              },
              {
                text: getLanguageStr('word1568', '本人所在组的电站'),
                value: 2,
                disabled: false
              },
              {
                text: getLanguageStr('word1569', '本人所在组及下级组的电站'),
                value: 3,
                disabled: false
              },
              {
                text: getLanguageStr('word1570', '全部电站'),
                value: 4,
                disabled: false
              }
            ]
          }
        },
        devices: {
          text: getLanguageStr('word164', '设备'),
          parent: 'devices',
          isOn: 0,
          selected: true,
          disabled: false,
          code: 'Z/B',
          funAuth: [
            {
              text: getLanguageStr('cmd200', '查看所属系统'),
              code: 'B/A/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('word781', '设备控制'),
              code: 'B/A/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('word1563', '设备升级'),
              code: 'B/A/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('cmd201', '查看设备详情'),
              code: 'B/A/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('cmd202', '查看报警信息'),
              code: 'B/A/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('cmd203', '查看连接信息'),
              code: 'B/A/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            },
            {
              text: getLanguageStr('cmd243', '查看操作日志'),
              code: 'B/A/A8',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'devices'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        arminfo: {
          text: getLanguageStr('word27', '报警'),
          parent: 'arminfo',
          isOn: 0,
          selected: true,
          disabled: false,
          code: 'Z/C',
          funAuth: [
            {
              text: getLanguageStr('cmd207', '查看报警详情'),
              code: 'A/D/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'arminfo'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        }
      }
    },
    maintain: {
      text: getLanguageStr('word1184', '运维'),
      isOn: 2, // 1:半选状态  0:未选状态 2：单个选中状态
      parent: 'maintain',
      selected: true,
      disabled: false,
      code: 'A',
      allModulesStatus: 1, // 所有的模块选择状态
      modules: {
        home: {
          text: getLanguageStr('word1562', '运维首页'),
          parent: 'home',
          isOn: 2,
          selected: true,
          disabled: false,
          code: 'A/A',
          funAuth: [
            {
              text: getLanguageStr('word1562', '运维首页'),
              code: 'A/A/A1',
              selected: true,
              isOn: 2,
              disabled: false,
              parent: 'home'
            }
          ],
          dataAuth: getLanguageStr('role3', '数据权限由全局中电站数据权限决定')
        },
        station: {
          text: getLanguageStr('word204', '电站'),
          parent: 'station',
          isOn: 1,
          selected: true,
          disabled: false,
          code: 'A/B',
          funAuth: [
            {
              text: getLanguageStr('cmd186', '查看电站列表'),
              code: 'A/B/A1',
              selected: true,
              isOn: 2,
              disabled: false,
              parent: 'station'
            },
            {
              text: getLanguageStr('cmd182', '添加新电站'),
              code: 'A/B/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'station'
            }

            //						{text: getLanguageStr("cmd192","查看电站报警"), code: 'A/B/A11', selected: false, isOn: 0, disabled: false, parent: 'station'},

            //						{text: getLanguageStr("cmd198","关联标签"), code: 'A/B/A17', selected: false, isOn: 0, disabled: false, parent: 'station'},
            //						{text: getLanguageStr("cmd199","移除标签"), code: 'A/B/A18', selected: false, isOn: 0, disabled: false, parent: 'station'},
          ],
          dataAuth: getLanguageStr('role3', '数据权限由全局中电站数据权限决定')
          // dataAuth: {
          //   resourceType: 1,
          //   value: 1,
          //   data: [
          //     {
          //       text: getLanguageStr('word1567', '本人的电站'),
          //       value: 1,
          //       disabled: false
          //     },
          //     {
          //       text: getLanguageStr('word1568', '本人所在组的电站'),
          //       value: 2,
          //       disabled: false
          //     },
          //     {
          //       text: getLanguageStr('word1569', '本人所在组及下级组的电站'),
          //       value: 3,
          //       disabled: false
          //     },
          //     {
          //       text: getLanguageStr('word1570', '全部电站'),
          //       value: 4,
          //       disabled: false
          //     }
          //   ]
          // }
        },
        outstation: {
          text: getLanguageStr('word204', '电站'),
          parent: 'outstation',
          isOn: 1,
          selected: true,
          disabled: false,
          code: 'OP',
          funAuth: [
            {
              text: getLanguageStr('cmd183', '编辑电站'),
              code: 'OP/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd184', '设置电站'),
              code: 'OP/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd188', '查看子系统/设备'),
              code: 'OP/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd189', '添加新子系统/设备'),
              code: 'OP/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd190', '编辑子系统/设备'),
              code: 'OP/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd191', '删除子系统/设备'),
              code: 'OP/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd192', '查看电站报警'),
              code: 'OP/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('cmd193', '查看关于电站'),
              code: 'OP/A8',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            },
            {
              text: getLanguageStr('manage324', '查看系统布局'),
              code: 'OP/A9',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'outstation'
            }
          ]
        },
        // equipment: {
        //   text: getLanguageStr('word1558', '电站关联设备'),
        //   parent: 'equipment',
        //   isOn: 0,
        //   selected: false,
        //   code: 'A/C',
        //   funAuth: [
        //     //						{text: getLanguageStr("cmd200","查看所属系统"), code: 'A/C/A1', selected: false, isOn: 0,disabled: false, parent: 'equipment'},
        //     //						{text: getLanguageStr("word781","设备控制"), code: 'A/C/A2', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //     //						{text: getLanguageStr("word1563","设备升级"), code: 'A/C/A3', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //     {text: getLanguageStr('cmd201', '查看设备详情'), code: 'A/C/A4', selected: false, isOn: 0, disabled: false, parent: 'equipment'}
        //     //						{text: getLanguageStr("cmd202","查看报警信息"), code: 'A/C/A5', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //     //						{text: getLanguageStr("cmd203","查看连接信息"), code: 'A/C/A6', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //     //						{text: getLanguageStr("cmd204","查看读写记录"), code: 'A/C/A7', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //     //						{text: getLanguageStr("cmd205","查看升级记录"), code: 'A/C/A8', selected: false, isOn: 0 ,disabled: false, parent: 'equipment'},
        //   ],
        //   dataAuth: getLanguageStr('phrase659', '数据权限由电站决定')
        // },
        alarm: {
          text: getLanguageStr('plant_alert1', '电站内报警'),
          parent: 'alarm',
          isOn: 0,
          selected: false,
          code: 'A/D',
          funAuth: [
            {
              text: getLanguageStr('plant_alert25', '查看电站报警列表'),
              code: 'A/D/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'alarm'
            }
          ],
          dataAuth: getLanguageStr('role3', '数据权限由全局中电站数据权限决定')
        }
      }
    },
    device: {
      text: getLanguageStr('device5', '设备库'),
      isOn: 0,
      parent: 'device',
      selected: false,
      disabled: false,
      code: 'B',
      allModulesStatus: 0,
      modules: {
        home: {
          text: getLanguageStr('depot2', '设备库首页'),
          isOn: 0,
          parent: 'home',
          selected: false,
          disabled: false,
          code: 'B/H',
          funAuth: [
            {
              text: getLanguageStr('depot2', '设备库首页'),
              code: 'B/H/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'home'
            }
          ],
          dataAuth: ''
        },
        deviced: {
          text: getLanguageStr('device5', '设备库'),
          isOn: 0,
          parent: 'deviced',
          selected: false,
          disabled: false,
          code: 'B/A',
          funAuth: [
            {
              text: getLanguageStr('device29', '查看设备库'),
              code: 'B/A/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'deviced'
            },
            {
              text: getLanguageStr('word1668', '设备导入'),
              code: 'B/A/A10',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'deviced'
            },
            {
              text: getLanguageStr('word1669', '设备删除'),
              code: 'B/A/A11',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'deviced'
            }

           

            // {text: getLanguageStr('cmd205', '查看升级记录'), code: 'B/A/A9', selected: false, isOn: 0, disabled: false, parent: 'device'}
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
      
        // fpsetting: {
        //   text: getLanguageStr('word1885', '配置管理'),
        //   isOn: 0,
        //   parent: 'fpsetting',
        //   selected: false,
        //   disabled: false,
        //   code: 'B/G',
        //   funAuth: [
        //     {
        //       text: getLanguageStr('word1886', '配置信息维护'),
        //       code: 'B/G/A1',
        //       selected: false,
        //       isOn: 0,
        //       disabled: false,
        //       parent: 'fpsetting'
        //     }
        //     // ,{
        //     //   text: getLanguageStr('word1913', '国网扶贫'),
        //     //   code: 'B/G/A2',
        //     //   selected: false,
        //     //   isOn: 0,
        //     //   disabled: false,
        //     //   parent: 'fpsetting'
        //     // }
            
        //   ],
        //   dataAuth: getLanguageStr('role2', '无数据权限控制')
        // },
        outdevice: {
          text: getLanguageStr('word164', '设备'),
          isOn: 0,
          parent: 'outdevice',
          selected: false,
          disabled: false,
          code: 'OD',
          funAuth: [
            {
              text: getLanguageStr('word781', '设备控制'),
              code: 'OD/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'device'
            },
            {
              text: getLanguageStr('word1563', '设备升级'),
              code: 'OD/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'device'
            }
          ]
        },
    
        logger: {
          text: getLanguageStr('word1664', '日志管理'),
          isOn: 0,
          parent: 'logger',
          selected: false,
          disabled: false,
          code: 'B/D',
          funAuth: [
            {
              text: getLanguageStr('cmd277', '设备操作日志'),
              code: 'B/D/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'logger'
            }
            // {text: getLanguageStr('word1684', '设备库日志'), code: 'B/D/A2', selected: false, isOn: 0, disabled: false, parent: 'alarm'}
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        }
        // alarm: {
        //   text: getLanguageStr('word1565', '设备关联报警'),
        //   isOn: 0,
        //   parent: 'alarm',
        //   selected: false,
        //   disabled: false,
        //   code: 'B/C',
        //   funAuth: [
        //     {text: getLanguageStr('cmd207', '查看报警详情'), code: 'B/C/A1', selected: false, isOn: 0, disabled: false, parent: 'alarm'}
        //   ],
        //   dataAuth: getLanguageStr('phrase667', '数据权限由设备决定')
        // },
      
        // station: {
        //   text: getLanguageStr('word1566', '设备关联电站'),
        //   isOn: 0,
        //   parent: 'station',
        //   selected: false,
        //   disabled: false,
        //   code: 'B/D',
        //   funAuth: [
        //     //						{text: getLanguageStr("cmd183","编辑电站"), code: 'B/D/A1', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd184","设置电站"), code: 'B/D/A2', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd185","删除电站"), code: 'B/D/A3', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     {text: getLanguageStr('cmd187', '查看电站详情'), code: 'B/D/A4', selected: false, isOn: 0, disabled: false, parent: 'station'}
        //     //						{text: getLanguageStr("cmd188","查看子系统/设备"), code: 'B/D/A5', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd189","添加新子系统/设备"), code: 'B/D/A6', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd190","编辑子系统/设备"), code: 'B/D/A7', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd191","删除子系统/设备"), code: 'B/D/A8', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd192","查看电站报警"), code: 'B/D/A9', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //     //						{text: getLanguageStr("cmd193","查看关于电站"), code: 'B/D/A10', selected: false, isOn: 0, disabled: false, parent: 'station'},
        //   ],
        //   dataAuth: getLanguageStr('phrase667', '数据权限由设备决定')
        // }
      }
    },
    product: {
      text: getLanguageStr('word1532', '产品'),
      isOn: 0,
      parent: 'product',
      selected: false,
      disabled: false,
      code: 'E',
      allModulesStatus: 0,
      modules: {
        productManage: {
          text: getLanguageStr('product2', '产品管理'),
          parent: 'productManage',
          isOn: 0,
          selected: false,
          code: 'B/E',
          funAuth: [
            {
              text: getLanguageStr('product1', '查看产品列表'),
              code: 'B/E/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'productManage'
            }, {
              text: getLanguageStr('product3', '编辑产品'),
              code: 'B/E/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'productManage'
            }, {
              text: getLanguageStr('product4', '转让产品'),
              code: 'B/E/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'productManage'
            }
           
          ],
          dataAuth: ''
        },
        fireManage: {
          text: getLanguageStr('word217', '固件管理'),
          isOn: 0,
          parent: 'fireManage',
          selected: false,
          disabled: false,
          code: 'B/B',
          funAuth: [
            // {text: getLanguageStr('word1517', '查看操作审计'), code: 'B/B/A1', selected: false, isOn: 0, disabled: false, parent: 'service'},

            {
              text: getLanguageStr('cmd210', '查看固件列表'),
              code: 'B/B/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'fireManage'
            },
            // {
            //   text: getLanguageStr('cmd211', '查看固件详情'),
            //   code: 'B/B/A3',
            //   selected: false,
            //   isOn: 0,
            //   disabled: false,
            //   parent: 'service'
            // },
            {
              text: getLanguageStr('device81', '上传固件信息'),
              code: 'B/B/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'fireManage'
            },
            {
              text: getLanguageStr('cmd279', '编辑固件信息'),
              code: 'B/B/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'fireManage'
            },
            {
              text: getLanguageStr('cmd213', '删除固件'),
              code: 'B/B/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'fireManage'
            }
          ],
          dataAuth: ''
        },
        zlManage: {
          text: getLanguageStr('device290', '指令管理'),
          parent: 'zlManage',
          isOn: 0,
          selected: false,
          code: 'E/A',
          funAuth: [
            {
              text: getLanguageStr('device309', '查看产品列表'),
              code: 'E/A/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'zlManage'
            }, {
              text: getLanguageStr('device310', '授权指令'),
              code: 'E/A/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'zlManage'
            }
          ],
          dataAuth: ''
        },
        batchtask: {
          text: getLanguageStr('task1', '批量任务'),
          isOn: 0,
          parent: 'batchtask',
          selected: false,
          disabled: false,
          code: 'B/F',
          funAuth: [
            {
              text: getLanguageStr('task57', '查看批量任务列表'),
              code: 'B/F/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            {
              text: getLanguageStr('task17', '创建任务'),
              code: 'B/F/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            {
              text: getLanguageStr('task35', '编辑任务'),
              code: 'B/F/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            {
              text: getLanguageStr('task58', '删除任务'),
              code: 'B/F/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            // {
            //   text: getLanguageStr('task60', '任务详情首页'),
            //   code: 'B/F/A5',
            //   selected: false,
            //   isOn: 0,
            //   disabled: false,
            //   parent: 'batchtask'
            // },
            {
              text: getLanguageStr('task59', '设备任务重发'),
              code: 'B/F/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            {
              text: getLanguageStr('task61', '设备任务终止'),
              code: 'B/F/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'batchtask'
            },
            // {
            //   text: getLanguageStr('task62', '关于任务'),
            //   code: 'B/F/A8',
            //   selected: false,
            //   isOn: 0,
            //   disabled: false,
            //   parent: 'batchtask'
            // }
          ],
          dataAuth: ''
        },
        archives: {
          text: getLanguageStr('device_file1', '设备档案'),
          parent: 'archives',
          isOn: 0,
          selected: false,
          code: 'B/G',
          funAuth: [
            {
              text: getLanguageStr('device_file1', '设备档案'),
              code: 'B/G/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'archives'
            }
            // {text: '体检', code: 'C/A/A2', selected: false, isOn: 0,disabled: false, parent: 'home'}
          ],
          dataAuth: ''
        }
      }
    },
    application: {
      text: getLanguageStr('word1291', '应用'),
      isOn: 0,
      parent: 'application',
      selected: false,
      disabled: false,
      code: 'C',
      allModulesStatus: 0,
      modules: {
        home: {
          text: getLanguageStr('app55_1', '应用首页'),
          parent: 'home',
          isOn: 0,
          selected: false,
          code: 'C/A',
          funAuth: [
            {
              text: getLanguageStr('app55_1', '应用首页'),
              code: 'C/A/A100',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'home'
            }
            // {text: '体检', code: 'C/A/A2', selected: false, isOn: 0,disabled: false, parent: 'home'}
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        screen: {
          text: getLanguageStr('word1868', '大屏'),
          parent: 'screen',
          isOn: 0,
          selected: false,
          code: 'C/B',
          funAuth: [
            {
              text: getLanguageStr('word1868', '大屏'),
              code: 'C/A/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'screen'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        inspect: {
          text: getLanguageStr('word1979', '体检'),
          parent: 'inspect',
          isOn: 0,
          selected: false,
          code: 'C/C',
          funAuth: [
            {
              text: getLanguageStr('word1979', '体检'),
              code: 'C/A/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'inspect'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        report: {
          text: getLanguageStr('word1290', '报表'),
          parent: 'report',
          isOn: 0,
          selected: false,
          code: 'C/D',
          funAuth: [
            {
              text: getLanguageStr('word1290', '报表'),
              code: 'C/A/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'report'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        wblust: {
          text: getLanguageStr('word1992', '维保记录'),
          parent: 'wblust',
          isOn: 0,
          selected: false,
          code: 'C/E',
          funAuth: [
            {
              text: getLanguageStr('word1993', '添加新维保记录'),
              code: 'C/A/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'wblust'
            },
            {
              text: getLanguageStr('role9', '查看维保记录'),
              code: 'C/A/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'wblust'
            },
            {
              text: getLanguageStr('role10', '删除维保记录'),
              code: 'C/A/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'wblust'
            },
            {
              text: getLanguageStr('word1994', '编辑维保记录'),
              code: 'C/A/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'wblust'
            }
          ],
          dataAuth: {
            resourceType: 6,
            value: 1,
            data: [
              {
                text: getLanguageStr('role14', '本人的维保记录'),
                value: 1,
                disabled: false
              },
              {
                text: getLanguageStr('role13', '本人所在部门的维保记录'),
                value: 2,
                disabled: false
              },
              {
                text: getLanguageStr(
                  'role12',
                  '本人所在部门及下级部门的维保记录'
                ),
                value: 3,
                disabled: false
              },
              {
                text: getLanguageStr('role11', '全部维保记录'),
                value: 4,
                disabled: false
              }
            ]
          }
        },
        electricity: {
          text: getLanguageStr('bill1', '电费记录'),
          parent: 'electricity',
          isOn: 0,
          selected: false,
          code: 'C/F',
          funAuth: [
            {
              text: getLanguageStr('manage344', '添加新的电费记录'),
              code: 'C/F/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            },
            {
              text: getLanguageStr('manage345', '查看电费记录'),
              code: 'C/F/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            },
            {
              text: getLanguageStr('manage346', '删除电费记录'),
              code: 'C/F/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            },
            {
              text: getLanguageStr('manage347', '编辑电费记录'),
              code: 'C/F/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            },
            {
              text: getLanguageStr('report1', '导出报表'),
              code: 'C/F/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            },
            {
              text: getLanguageStr('manage348', '编辑电费设置'),
              code: 'C/F/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'electricity'
            }
          ],
          dataAuth: {
            resourceType: 7,
            value: 1,
            data: [
              {
                text: getLanguageStr('manage349', '本人的电费记录'),
                value: 1,
                disabled: false
              },
              {
                text: getLanguageStr('manage350', '本人所在部门的电费记录'),
                value: 2,
                disabled: false
              },
              {
                text: getLanguageStr(
                  'manage351',
                  '本人所在部门及下级部门的电费记录'
                ),
                value: 3,
                disabled: false
              },
              {
                text: getLanguageStr('manage352', '全部电费记录'),
                value: 4,
                disabled: false
              }
            ]
          }
        },
        ivcurve: {
          text: getLanguageStr('device257', 'IV曲线'),
          parent: 'ivcurve',
          isOn: 0,
          selected: false,
          code: 'C/G',
          funAuth: [
            {
              text: getLanguageStr('device257', 'IV曲线'),
              code: 'C/G/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'ivcurve'
            }
          ],
          dataAuth: ''
        },
      }
    },
    manage: {
      text: getLanguageStr('word1429', '管理'),
      isOn: 0,
      parent: 'manage',
      selected: false,
      disabled: false,
      code: 'D',
      allModulesStatus: 0,
      modules: {
        provider: {
          text: getLanguageStr('word1652', '关于商家'),
          isOn: 0,
          parent: 'provider',
          selected: false,
          disabled: false,
          code: 'D/C',
          funAuth: [
            // 布局的特殊性角色 成员合二为一
            // 角色中的字段id 只是为了循环虚拟DOM优化使用，不然也是用index的话，造成key重复
            {
              text: getLanguageStr('manage258', '查看关于商家'),
              code: 'D/C/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'provider',
              id: 'a'
            },
            {
              text: getLanguageStr('word1644', '编辑商家'),
              code: 'D/C/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'provider',
              id: 'b'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },

        rolerelation: {
          text: getLanguageStr('word1927', '外部关系管理'),
          isOn: 0,
          parent: 'rolerelation',
          selected: false,
          disabled: false,
          code: 'D/D',
          funAuth: [
            {
              text: getLanguageStr('cmd245', '查看外部关系与角色'),
              code: 'D/D/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd270', '查看商家列表'),
              code: 'D/D/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd271', '查看商家详情'),
              code: 'D/D/A14',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd272', '添加新商家'),
              code: 'D/D/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('plant112', '编辑商家'),
              code: 'D/D/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd273', '删除商家'),
              code: 'D/D/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('word1666', '查看用户列表'),
              code: 'D/D/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd274', '查看用户详情'),
              code: 'D/D/A15',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd275', '添加新用户'),
              code: 'D/D/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('manage177', '编辑用户'),
              code: 'D/D/A8',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd267', '删除用户'),
              code: 'D/D/A9',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('word1667', '查看外部角色列表'),
              code: 'D/D/A10',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd235', '添加新外部角色'),
              code: 'D/D/A11',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('cmd268', '编辑外部角色'),
              code: 'D/D/A12',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            },
            {
              text: getLanguageStr('manage246', '删除外部角色'),
              code: 'D/D/A13',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'rolerelation'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        mark: {
          text: getLanguageStr('manage239', '标签管理'),
          isOn: 0,
          parent: 'mark',
          selected: false,
          disabled: false,
          code: 'D/B',
          funAuth: [
            {
              text: getLanguageStr('cmd223', '查看标签列表'),
              code: 'D/B/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'mark'
            },
            {
              text: getLanguageStr('cmd224', '添加新标签'),
              code: 'D/B/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'mark'
            },
            {
              text: getLanguageStr('cmd225', '编辑标签'),
              code: 'D/B/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'mark'
            },
            {
              text: getLanguageStr('cmd226', '删除标签'),
              code: 'D/B/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'mark'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },

        message: {
          text: getLanguageStr('word1934', '消息管理'),
          isOn: 0,
          parent: 'message',
          selected: false,
          disabled: false,
          code: 'D/E',
          funAuth: [
            {
              text: getLanguageStr('word1962', '报警消息管理'),
              code: 'D/E/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'message'
            }
          ],
          dataAuth: getLanguageStr('role2', '无数据权限控制')
        },
        memberRole: {
          text: getLanguageStr('word1621', '内部组织架构'), // 成员/角色--> 内部组织架构
          isOn: 0,
          parent: 'memberRole',
          selected: false,
          disabled: false,
          code: 'D/A',
          funAuth: [
            // 布局的特殊性角色 成员合二为一
            // 角色中的字段id 只是为了循环虚拟DOM优化使用，不然也是用index的话，造成key重复
            {
              text: getLanguageStr('cmd214', '查看内部组织架构'), // 查看成员/角色-->查看内部组织架构
              code: 'D/A/A1',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'a'
            },
            {
              text: getLanguageStr('cmd215', '查看部门/成员列表'),
              code: 'D/A/A2',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'b'
            },
            {
              text: getLanguageStr('cmd276', '查看成员详情'),
              code: 'D/A/A10',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'k'
            },
            {
              text: getLanguageStr('role15', '添加新部门/成员'),
              code: 'D/A/A3',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'c'
            },

            {
              text: getLanguageStr('cmd217', '编辑部门/成员'),
              code: 'D/A/A4',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'd'
            },
            {
              text: getLanguageStr('cmd218', '删除部门/成员'),
              code: 'D/A/A5',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'e'
            },
            {
              text: getLanguageStr('cmd219', '查看角色列表'),
              code: 'D/A/A6',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'f'
            },
            {
              text: getLanguageStr('manage84', '添加新角色'),
              code: 'D/A/A7',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'g'
            },
            {
              text: getLanguageStr('cmd221', '编辑角色'),
              code: 'D/A/A8',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'h'
            },
            {
              text: getLanguageStr('cmd222', '删除角色'),
              code: 'D/A/A9',
              selected: false,
              isOn: 0,
              disabled: false,
              parent: 'memberRole',
              id: 'i'
            }
          ],
          dataAuth: {
            resourceType: 2,
            value: 1,
            data: [
              {
                text: getLanguageStr('word1572', '本人所在组/本人'),
                value: 1,
                disabled: false
              },
              {
                text: getLanguageStr('word1573', '本人所在组/本人所在组的成员'),
                value: 2,
                disabled: false
              },
              {
                text: getLanguageStr(
                  'word1574',
                  '本人所在组及下级组/本人所在组及下级组的成员'
                ),
                value: 3,
                disabled: false
              },
              {
                text: getLanguageStr('word1575', '全部组/全部成员'),
                value: 4,
                disabled: false
              }
            ]
          },
          dataAuthOther: getLanguageStr('role2', '无数据权限控制')
        }
      }
    }
  }
}
if (stage.setting.loc.shieldBlackList.inspect) {
  delete state.originRolesMap.application.modules.inspect
}

if (stage.setting.loc.shieldBlackList.maintenance) {
  delete state.originRolesMap.application.modules.wblust
}
if (stage.setting.loc.shieldBlackList.report) {
  delete state.originRolesMap.application.modules.report
}
if (stage.setting.loc.shieldBlackList.display) {
  delete state.originRolesMap.application.modules.screen
}
if (stage.setting.loc.shieldBlackList.batchTask) {
  delete state.originRolesMap.product.modules.batchtask
}
if (stage.setting.loc.shieldBlackList.archives) {
  delete state.originRolesMap.product.modules.archives
}
if (stage.setting.loc.shieldBlackList.managemessage) {
  delete state.originRolesMap.manage.modules.message
}
// state.originRolesMap.application.modules
const getters = {
  roleList: state => state.roleList,
  functionalList: state => state.functionalList,
  structList: state => state.structList,
  originRolesMap: state => state.originRolesMap
}
const actions = {
  // 获取角色列表
  GetRoleList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      roleFunc
        .getRoleList(data)
        .then(response => {
          let { roleList } = response
          commit('GET_ROLE_LIST', roleList)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取职能列表
  GetFunctionalList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      roleFunc
        .getFunctionalList(data)
        .then(response => {
          let { roleList } = response
          commit('GET_FUNCTIONAL_LIST', roleList)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取职能树
  GetStructList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      roleFunc
        .getFunctionalList(data)
        .then(response => {
          commit('GET_STRUCT_LIST', response)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  GET_ROLE_LIST: (state, roleList) => {
    state.roleList = roleList
  },
  GET_FUNCTIONAL_LIST: (state, functionalList) => {
    state.functionalList = functionalList
  },
  GET_STRUCT_LIST: (state, structList) => {
    state.structList = structList
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/roleFunc.js